import { CompensationMethodData } from "@redotech/redo-customer-portal-shared/flow/util";
import { ExchangeVariant } from "@redotech/redo-model/draft-return/draft-return-items";
import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { Step } from "@redotech/redo-model/return-flow";
import { ReturnOptionMethod } from "@redotech/redo-model/return-flow/return-option";
import { memo, useCallback, useEffect } from "react";
import { EnsoEngravingFee } from "./enso-engraving";

export const SubmitClaim = memo(function SubmitClaim({
  submitItem,
  sameItemVariant,
  flowStep,
  showEnsoEngraving,
  returnType,
}: {
  submitItem: (data: CompensationMethodData) => void;
  sameItemVariant: ExchangeVariant | null;
  flowStep: Step.SubmitClaim;
  showEnsoEngraving: boolean;
  returnType: ReturnTypeEnum;
}) {
  const handleSubmit = useCallback((data: CompensationMethodData) => {
    submitItem(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (showEnsoEngraving) {
      return;
    }
    if (
      flowStep.option.method.type === ReturnOptionMethod.EXCHANGE &&
      sameItemVariant
    ) {
      handleSubmit({
        variantExchangeItem: {
          variantId: sameItemVariant.id,
          preserveProperties: true,
          image: sameItemVariant.image,
          title: sameItemVariant.title,
        },
      });
    } else {
      handleSubmit({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {showEnsoEngraving && (
        <EnsoEngravingFee
          multipleChoiceAnswers={[]}
          returnType={returnType}
          selectedVariant={sameItemVariant}
          submitItem={submitItem}
        />
      )}
    </>
  );
});
